// src/widgets/InstanceEventWidget.tsx

import React, { useCallback } from 'react';
import { ResponseEventWidget, ResponseEventItem, ResponseEventUpdate } from './ResponseEventWidget';
import { RealtimeEvent } from '../utils/events.js';
import { useFabricService, MemoryIndexes } from '../contexts/FabricServiceContext';
import { DropdownOption } from '../types/Dropdown';

interface InstanceEventWidgetProps {
  eventType: string;
  storageField: string;
  placeholder?: string;
  itemContent: (eventItem: ResponseEventItem) => JSX.Element;
  speakerName: (eventItem: ResponseEventItem) => string | JSX.Element;
  filterCondition: (eventItem: ResponseEventItem, selectedModule: string, selectedFilters: (string | undefined)[]) => boolean;
  eventUpdate: (event: RealtimeEvent, output: ResponseEventUpdate, memoryIndexes?: MemoryIndexes[]) => void;
}

export const InstanceEventWidget: React.FC<InstanceEventWidgetProps> = (props) => {
  const { fabricBuilderEvents } = useFabricService();

  const processInstanceEvents = useCallback(() => {
    const new_modules: string[] = [];
    const new_agents: DropdownOption[] = [];
    const new_items: ResponseEventItem[] = [];

    const update = {
      modules: new_modules,
      filters: new_agents,
      items: new_items
    };

    fabricBuilderEvents
      .filter(
        (instanceEvent) =>
          instanceEvent.event.type === 'fabric.instance.generate.output_item.added'
      )
      .forEach((instanceEvent) => {
        props.eventUpdate(instanceEvent, update);
      });

    return update;
  }, [fabricBuilderEvents, props.eventType, props.eventUpdate]);

  const resetWidget = useCallback((clearAll: () => void) => {
    if (fabricBuilderEvents.length === 0) {
      clearAll();
    }
  }, [fabricBuilderEvents])

  return (
    <ResponseEventWidget
      {...props}
      processEvents={processInstanceEvents}
      resetWidget={resetWidget}
      useResponseId={false}
    />
  );
};